import { render } from "./index.vue?vue&type=template&id=67264518&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=67264518&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=67264518&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67264518"]])

export default __exports__